import React from 'react';
import { DeleteTarget } from '../utils/types';

interface DeleteModalProps {
  isOpen: boolean;
  deleteTarget: DeleteTarget | null;
  onClose: () => void;
  onConfirmDelete: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isOpen,
  deleteTarget,
  onClose,
  onConfirmDelete
}) => {
  if (!isOpen || !deleteTarget) return null;

  const getMessage = () => {
    switch (deleteTarget.type) {
      case 'dossier':
        return `Êtes-vous sûr de vouloir supprimer le dossier "${deleteTarget.data.reference}" (${deleteTarget.data.nom}) et tous ses sous-dossiers ?`;
      case 'transfert':
        return `Êtes-vous sûr de vouloir supprimer le dossier de transfert "${deleteTarget.data.reference}" (${deleteTarget.data.nom}) et tous ses fichiers ?`;
      case 'user':
        return `Êtes-vous sûr de vouloir supprimer l'utilisateur "${deleteTarget.data.username}" ?`;
      case 'sousdossier':
        return `Êtes-vous sûr de vouloir supprimer le sous-dossier "${deleteTarget.data.nom}" et tous ses fichiers ?`;
      case 'file':
        return `Êtes-vous sûr de vouloir supprimer le fichier "${deleteTarget.data.nomOriginal}" ?`;
      default:
        return 'Êtes-vous sûr de vouloir effectuer cette suppression ?';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4 backdrop-blur-sm">
      <div className="bg-white rounded-lg max-w-full sm:max-w-md w-full shadow-2xl mx-2 sm:mx-4">
        <div className="p-4 sm:p-6">
          <div className="flex items-center justify-center w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 bg-red-100 rounded-full">
            <svg className="w-6 h-6 sm:w-8 sm:h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 text-center mb-2">
            Confirmer la suppression
          </h3>

          <p className="text-gray-600 text-center mb-4 sm:mb-6 text-sm">
            {getMessage()}
            <br />
            <span className="text-red-600 font-medium">Cette action est irréversible.</span>
          </p>

          <div className="flex space-x-2 sm:space-x-4">
            <button
              onClick={onClose}
              className="flex-1 px-3 sm:px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-all duration-300 text-sm"
            >
              Annuler
            </button>
            <button
              onClick={onConfirmDelete}
              className="flex-1 px-3 sm:px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-lg transition-all duration-300 text-sm"
            >
              Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
